"use client"

import { useState, useEffect, useRef } from "react"
import { Button, Pagination } from "react-bootstrap"
import Select from "react-select"
import { useNavigate, useParams, Link } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import countryStateCity from "./countriesStatesCities.json"
import {
  createPatientAction,
  updatePatientAction,
  addMarriageInfoAction,
  addAddressInfoAction,
  addOtherInfoAction,
  getPatientlistbygenderAction,
  getPatientDetailsAction,
} from "../../../../store/actions/PatientsAction"
import { getBranchesAction } from "../../../../store/actions/BranchAction"
import { getDiseasesAction } from "../../../../store/actions/DiseasesAction"
import { getAdminUsersAction } from "../../../../store/actions/AdminUserAction"
import { handleSuccess, showErrorAlert } from "../../../../services/ErrorHandlingService"
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import Loader from "../../Common/Loader.jsx"

// Options for Diseases and Lead Source

const occupationOptions = [
  { value: "Doctor", label: "Doctor" },
  { value: "Nurse", label: "Nurse" },
  { value: "Engineer", label: "Engineer" },
  { value: "Teacher", label: "Teacher" },
  { value: "Farmer", label: "Farmer" },
  { value: "Housewife", label: "Housewife" },
  { value: "Student", label: "Student" },
  { value: "Businessman", label: "Businessman" },
  { value: "Driver", label: "Driver" },
  { value: "Electrician", label: "Electrician" },
  { value: "Plumber", label: "Plumber" },
  { value: "Carpenter", label: "Carpenter" },
  { value: "Lawyer", label: "Lawyer" },
  { value: "Police Officer", label: "Police Officer" },
  { value: "Artist", label: "Artist" },
  { value: "Actor", label: "Actor" },
  { value: "Scientist", label: "Scientist" },
  { value: "Retired", label: "Retired" },
  { value: "Unemployed", label: "Unemployed" },
  { value: "Other", label: "Other" },
]

const initialFormState = {
  first_name: "",
  middle_name: "",
  last_name: "",
  date_of_birth: "",
  whatsapp_contact_no: "",
  additional_contact_no: "",
  patient_email: "",
  weight: "",
  height: "",
  id_proof: "",
  id_number: "",
  disease_names: ["maleria"],
  gender: "",
  occupation: "",
  patient_photo: null,

  // Marriage info
  maritalStatus: "No",
  marriageEntries: [
    {
      marriageHistory: "1st",
      marriageDate: "",
      spouseOption: "withoutSpouse",
      spouseName: "",
      spouseMobile: "",
      spouseEmail: "",
      spouseDOB: "",
      spouseDetails: null,
    },
  ],

  // Address info
  tempAddressLine1: "",
  tempAddressLine2: "",
  tempArea: "",
  tempCountry: "",
  tempState: "",
  tempCity: "",
  tempPincode: "",
  useTempAddress: false,
  addressLine1: "",
  addressLine2: "",
  area: "",
  country: "",
  state: "",
  city: "",
  pincode: "",

  // Other info
  adName: "",
  adSet: "",
  campaignName: "",
  leadSource: "",
  status: "",
  priority: "",
  modifiedBy: "",
  userType: "",
  branch: "",
  treatmentHistory: "",
}

const formatPatientsForDropdown = (patients) => {
  if (!Array.isArray(patients)) return []

  return patients.map((patient) => ({
    value: patient.patient_id,
    label: (patient.patient_name || "").trim(),
  }))
}

const AddPatients = () => {
  const { id: patientId } = useParams() // Destructure and rename for clarity
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [formData, setFormData] = useState(initialFormState)
  const [countries, setCountries] = useState([])
  const [errors, setErrors] = useState({})
  const [states, setStates] = useState([])
  const [cities, setCities] = useState([])
  const [permCountries, setPermCountries] = useState([])
  const [permStates, setPermStates] = useState([])
  const [permCities, setPermCities] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [loading, setLoading] = useState(false) // for submit button
  const [fetching, setFetching] = useState(false) // for prefill or API load

  const branches = useSelector((state) => state.branches?.branches || [])
  const diseases = useSelector((state) => state.diseases.diseases || [""])
  const adminUsers = useSelector((state) => state.adminUser.adminUsers)
  const patientDetails = useSelector((state) => state.patients?.patientDetails)
  // validation functions
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return emailRegex.test(email)
  }

  const validatePhone = (phone) => {
    const phoneRegex = /^[0-9]{10}$/
    return phoneRegex.test(phone.replace(/\D/g, ""))
  }

  const validatePincode = (pincode) => {
    const pincodeRegex = /^[0-9]{6}$/
    return pincodeRegex.test(pincode)
  }

  const validateDate = (date) => {
    if (!date) return false
    const dateObj = new Date(date)
    const today = new Date()
    return dateObj instanceof Date && !isNaN(dateObj) && dateObj <= today
  }

  const validateIdNumber = (idProof, idNumber) => {
    if (!idNumber) return false

    switch (idProof) {
      case "PAN":
        return /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(idNumber)
      case "Aadhar":
        return /^[0-9]{12}$/.test(idNumber.replace(/\s/g, ""))
      case "Driving License":
        return idNumber.length >= 8 && idNumber.length <= 20
      default:
        return idNumber.length > 0
    }
  }
  const clearSpouseFieldError = (fieldName, index) => {
    const errorKey = `${fieldName}_${index}`
    if (errors[errorKey]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[errorKey]
        return newErrors
      })
    }
  }

  const fieldRefs = useRef({})

  const validateForm = () => {
    const newErrors = {}

    // Personal Information Validation
    if (!formData.first_name.trim()) {
      newErrors.first_name = "First name is required"
    } else if (formData.first_name.trim().length < 2) {
      newErrors.first_name = "First name must be at least 2 characters"
    } else if (!/^[a-zA-Z\s]+$/.test(formData.first_name.trim())) {
      newErrors.first_name = "First name should contain only letters"
    }

    if (!formData.last_name.trim()) {
      newErrors.last_name = "Last name is required"
    } else if (formData.last_name.trim().length < 2) {
      newErrors.last_name = "Last name must be at least 2 characters"
    } else if (!/^[a-zA-Z\s]+$/.test(formData.last_name.trim())) {
      newErrors.last_name = "Last name should contain only letters"
    }
    // if (!formData.middle_name.trim()) {
    //   newErrors.middle_name = "middle name is required"
    // } else if (formData.middle_name.trim().length < 2) {
    //   newErrors.middle_name = "Last name must be at least 2 characters"
    // } else if (!/^[a-zA-Z\s]+$/.test(formData.middle_name.trim())) {
    //   newErrors.middle_name = "Last name should contain only letters"
    // }

    if (formData.patient_email.trim()) {
      if (!validateEmail(formData.patient_email)) {
        newErrors.patient_email = "Please enter a valid email address"
      }
    }

    if (!formData.whatsapp_contact_no.trim()) {
      newErrors.whatsapp_contact_no = "WhatsApp contact number is required"
    } else if (!validatePhone(formData.whatsapp_contact_no)) {
      newErrors.whatsapp_contact_no = "Please enter a valid 10-digit phone number"
    }

    if (formData.additional_contact_no) {
      if (!validatePhone(formData.additional_contact_no)) {
        newErrors.additional_contact_no = "Please enter a valid 10-digit phone number"
      }
    }

    if (
      formData.patient_photo &&
      typeof formData.patient_photo !== "string" && // only validate if it's a file
      (formData.patient_photo.size > 2 * 1024 * 1024 ||
        !["image/jpeg", "image/png"].includes(formData.patient_photo.type))
    ) {
      newErrors.patient_photo = "Photo must be JPG/PNG and less than 2MB"
    }

    if (!formData.gender) {
      newErrors.gender = "Gender is required"
    }

    if (!formData.date_of_birth) {
      newErrors.date_of_birth = "Date of birth is required"
    } else if (!validateDate(formData.date_of_birth)) {
      newErrors.date_of_birth = "Please enter a valid date"
    }

    if (!formData.height) {
      newErrors.height = "Height is required"
    } else if (isNaN(formData.height) || formData.height <= 0 || formData.height > 300) {
      newErrors.height = "Please enter a valid height (1-300 cm)"
    }

    if (!formData.weight) {
      newErrors.weight = "Weight is required"
    } else if (isNaN(formData.weight) || formData.weight <= 0 || formData.weight > 500) {
      newErrors.weight = "Please enter a valid weight (1-500 kg)"
    }

    if (!formData.occupation.trim()) {
      newErrors.occupation = "Occupation is required"
    } else if (formData.occupation.trim().length < 2) {
      newErrors.occupation = "Occupation must be at least 2 characters"
    }

    if (!formData.id_proof) {
      newErrors.id_proof = "ID proof type is required"
    }

    if (!formData.id_number.trim()) {
      newErrors.id_number = "ID number is required"
    } else if (!validateIdNumber(formData.id_proof, formData.id_number)) {
      newErrors.id_number = `Please enter a valid ${formData.id_proof} number`
    }

    if (!formData.disease_names || !Array.isArray(formData.disease_names) || formData.disease_names.length === 0) {
      newErrors.disease_names = "At least one disease must be selected"
    }

    if (!formData.branch) {
      newErrors.branch = "Branch selection is required"
    }

    // Marriage Information Validation
    if (formData.maritalStatus === "Yes") {
      formData.marriageEntries.forEach((entry, index) => {
        // 🔹 Marriage Date validation
        if (!entry.marriageDate) {
          newErrors[`marriageDate_${index}`] = "Marriage date is required"
        } else if (!validateDate(entry.marriageDate)) {
          newErrors[`marriageDate_${index}`] = "Please enter a valid marriage date"
        }

        // 🔹 With Spouse validations
        if (entry.spouseOption === "withSpouse") {
          if (!entry.spouseDetails) {
            newErrors[`spouseDetails_${index}`] = "Please select spouse from patients"
          }

          // ✅ Optional fields: validate only if entered
          if (entry.spouseMobile && entry.spouseMobile.trim()) {
            if (!validatePhone(entry.spouseMobile)) {
              newErrors[`spouseMobile_${index}`] = "Please enter a valid 10-digit mobile number"
            }
          }

          if (entry.spouseEmail && entry.spouseEmail.trim()) {
            if (!validateEmail(entry.spouseEmail)) {
              newErrors[`spouseEmail_${index}`] = "Please enter a valid email address"
            }
          }

          if (entry.spouseDOB && entry.spouseDOB.trim()) {
            if (!validateDate(entry.spouseDOB)) {
              newErrors[`spouseDOB_${index}`] = "Please enter a valid date of birth"
            }
          }

          if (entry.spouseOccupation && entry.spouseOccupation.trim()) {
            if (!/^[a-zA-Z\s]+$/.test(entry.spouseOccupation.trim())) {
              newErrors[`spouseOccupation_${index}`] = "Occupation should contain only letters"
            }
          }
        }

        // 🔹 Without Spouse validations
        if (entry.spouseOption === "withoutSpouse") {
          if (entry.spouseName && entry.spouseName.trim()) {
            if (!/^[a-zA-Z\s]+$/.test(entry.spouseName.trim())) {
              newErrors[`spouseName_${index}`] = "Spouse name should contain only letters"
            }
          }
        }
      })
    }

    // Temporary Address Validation
    if (!formData.tempAddressLine1.trim()) {
      newErrors.tempAddressLine1 = "Address Line 1 is required"
    } else if (formData.tempAddressLine1.trim().length < 5) {
      newErrors.tempAddressLine1 = "Address Line 1 must be at least 5 characters"
    }
    if (!formData.tempAddressLine2.trim()) {
      newErrors.tempAddressLine2 = "Address Line 2 is required"
    } else if (formData.tempAddressLine2.trim().length < 5) {
      newErrors.tempAddressLine2 = "Address Line 2 must be at least 5 characters"
    }

    if (!formData.tempArea.trim()) {
      newErrors.tempArea = "Area is required"
    } else if (formData.tempArea.trim().length < 2) {
      newErrors.tempArea = "Area must be at least 2 characters"
    }

    if (!formData.tempCountry) {
      newErrors.tempCountry = "Country is required"
    }

    if (!formData.tempState) {
      newErrors.tempState = "State is required"
    }

    if (!formData.tempCity) {
      newErrors.tempCity = "City is required"
    }

    if (!formData.tempPincode.trim()) {
      newErrors.tempPincode = "Pincode is required"
    } else if (!validatePincode(formData.tempPincode)) {
      newErrors.tempPincode = "Please enter a valid 6-digit pincode"
    }

    // Permanent Address Validation (if not using temp address)
    if (!formData.useTempAddress) {
      if (!formData.addressLine1.trim()) {
        newErrors.addressLine1 = "Address Line 1 is required"
      } else if (formData.addressLine1.trim().length < 2) {
        newErrors.addressLine1 = "Address Line 1 must be at least 5 characters"
      }
      if (!formData.addressLine2.trim()) {
        newErrors.addressLine2 = "Address Line 2 is required"
      } else if (formData.addressLine2.trim().length < 2) {
        newErrors.addressLine2 = "Address Line 2 must be at least 5 characters"
      }

      if (!formData.area.trim()) {
        newErrors.area = "Area is required"
      } else if (formData.area.trim().length < 2) {
        newErrors.area = "Area must be at least 2 characters"
      }

      if (!formData.country) {
        newErrors.country = "Country is required"
      }

      if (!formData.state) {
        newErrors.state = "State is required"
      }

      if (!formData.city) {
        newErrors.city = "City is required"
      }

      if (!formData.pincode.trim()) {
        newErrors.pincode = "Pincode is required"
      } else if (!validatePincode(formData.pincode)) {
        newErrors.pincode = "Please enter a valid 6-digit pincode"
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors) // ✅ update state so error messages show

      // Scroll to first error
      const firstErrorKey = Object.keys(newErrors)[0]
      const errorEl = fieldRefs.current[firstErrorKey]
      if (errorEl?.scrollIntoView) {
        errorEl.scrollIntoView({ behavior: "smooth", block: "center" })
      }

      return false
    }

    setErrors({}) // clear errors if valid
    return true
  }

  const handleChangeWithValidation = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))

    // Clear field error when user starts typing
    if (errors[name]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[name]
        return newErrors
      })
    }
  }

  const clearFieldError = (fieldName) => {
    if (errors[fieldName]) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors[fieldName]
        return newErrors
      })
    }
  }
  // Fetch patient details when ID is available
  // useEffect(() => {
  //   if (patientId) {
  //     setIsLoading(true);
  //     dispatch(getPatientDetailsAction(patientId)).finally(() =>
  //       setIsLoading(false)
  //     );
  //   }
  // }, [dispatch, patientId]);
  useEffect(() => {
    if (patientId) {
      setFetching(true)
      dispatch(getPatientDetailsAction(patientId)).finally(() => setFetching(false))
    }
  }, [dispatch, patientId])

  // Populate form data when patient details are available
  useEffect(() => {
    if (patientDetails && patientId) {
      const {
        first_name,
        middile_name,
        last_name,
        whatsapp_contact_no,
        patient_email,
        patient_photo,
        branch,
        additional_contact_no,
        date_of_birth,
        height,
        weight,
        occupation,
        id_proof,
        id_number,
        gender,
        husband_or_spouse_name,
        age,
        marriage_history,
        marriage_date,
        diseases,
        disease_status,
        spouse_option,
        marriageInfo,
        TemporaryAddress,
        PermanentAddress,
        OtherInfo,
      } = patientDetails

      const diseaseNames =
        diseases?.length > 1
          ? diseases.map((d) => d.disease_name).join(", ")
          : diseases?.length === 1
            ? diseases[0].disease_name
            : ""

      setFormData({
        patient_id: patientId,
        patient_code: patientDetails.patient_code || "",
        first_name: first_name || "",
        middle_name: middile_name || "",
        last_name: last_name || "",
        name: `${first_name || ""} ${middile_name || ""} ${last_name || ""}`,
        whatsapp_contact_no: whatsapp_contact_no,
        email: patient_email,
        patient_email: patient_email,
        patient_photo: patient_photo,
        branch: branch ? String(branch) : "",
        additional_contact_no: additional_contact_no,
        date_of_birth: date_of_birth || "",
        height: height,
        weight: weight,
        occupation: occupation,
        id_proof: id_proof,
        id_number: id_number,
        gender: gender,
        spouseName: husband_or_spouse_name,
        age: age,
        marriageHistory: marriage_history,
        marriageDate: marriage_date,
        currentDisease: diseaseNames,
        disease_names: patientDetails.diseases?.map((d) => String(d.disease_id)) || [],
        diseaseStatus: disease_status,
        spouseOption: spouse_option,
        maritalStatus: marriageInfo?.length > 0 ? "Yes" : "No",

        // Marriage Info
        marriageEntries:
          marriageInfo?.length > 0
            ? marriageInfo.map((info, index) => ({
                marriageHistory: info.marriage_history || `${index + 1}${getOrdinalSuffix(index + 1)}`,
                marriageDate: info.date_of_marriage || "",
                spouseOption: info.spouse_option === "Without Spouse" ? "withoutSpouse" : "withSpouse",
                spouseName: info.husband_or_spouse_name || "",
                spouseDetails: info.spouse_details || null,
              }))
            : initialFormState.marriageEntries,

        // Temporary Address
        tempAddressLine1: TemporaryAddress?.address_line1 || "",
        tempAddressLine2: TemporaryAddress?.address_line2 || "",
        tempArea: TemporaryAddress?.area || "",
        tempCity: TemporaryAddress?.city === "0" ? "" : TemporaryAddress?.city || "",
        tempCountry: TemporaryAddress?.country === "0" ? "" : TemporaryAddress?.country || "",
        tempState: TemporaryAddress?.state === "0" ? "" : TemporaryAddress?.state || "",
        tempPincode: TemporaryAddress?.pincode || "",

        // Permanent Address
        addressLine1: PermanentAddress?.address_line1 || "",
        addressLine2: PermanentAddress?.address_line2 || "",
        area: PermanentAddress?.area || "",
        city: PermanentAddress?.city === "0" ? "" : PermanentAddress?.city || "",
        state: PermanentAddress?.state === "0" ? "" : PermanentAddress?.state || "",
        country: PermanentAddress?.country === "0" ? "" : PermanentAddress?.country || "",
        pincode: PermanentAddress?.pincode || "",
        useTempAddress: false,

        // Other Info
        adName: OtherInfo?.ad_name || "",
        adSet: OtherInfo?.ad_set || "",
        campaignName: OtherInfo?.campaign_name || "",
        leadSource: OtherInfo?.lead_source || "",
        status: OtherInfo?.status || "",
        priority: OtherInfo?.priority || "",
        modifiedBy: OtherInfo?.modified_by || "",
        userType: OtherInfo?.user_type ? String(OtherInfo.user_type) : "",
        treatmentHistory: OtherInfo?.treatment_history || "",
      })
    }
  }, [patientDetails, patientId])
  useEffect(() => {
    if (formData.useTempAddress) {
      setFormData((prev) => ({
        ...prev,
        addressLine1: prev.tempAddressLine1,
        addressLine2: prev.tempAddressLine2,
        area: prev.tempArea,
        country: prev.tempCountry,
        state: prev.tempState,
        city: prev.tempCity,
        pincode: prev.tempPincode,
      }))
    }
  }, [
    formData.useTempAddress,
    formData.tempAddressLine1,
    formData.tempAddressLine2,
    formData.tempArea,
    formData.tempCountry,
    formData.tempState,
    formData.tempCity,
    formData.tempPincode,
  ])

  // Reset form when switching between add/edit modes
  useEffect(() => {
    if (!patientId) {
      setFormData(initialFormState)
    }
  }, [patientId])

  useEffect(() => {
    dispatch(getBranchesAction(false))
  }, [dispatch])
  useEffect(() => {
    dispatch(getDiseasesAction(false))
  }, [dispatch])

  useEffect(() => {
    dispatch(getAdminUsersAction(false))
  }, [])
  // Load countries
  useEffect(() => {
    const countryList = countryStateCity.map((country) => ({
      value: country.name,
      label: country.name,
    }))
    setCountries(countryList)
    setPermCountries(countryList)
  }, [])

  // Load states based on temp country
  useEffect(() => {
    if (formData.tempCountry) {
      const selectedCountry = countryStateCity.find((c) => c.name === formData.tempCountry)
      setStates(
        selectedCountry?.states?.map((state) => ({
          value: state.name,
          label: state.name,
        })) || [],
      )
    } else {
      setStates([])
    }
  }, [formData.tempCountry])

  // Load cities based on temp state
  useEffect(() => {
    if (formData.tempCountry && formData.tempState) {
      const selectedCountry = countryStateCity.find((c) => c.name === formData.tempCountry)
      const selectedState = selectedCountry?.states?.find((s) => s.name === formData.tempState)
      setCities(
        selectedState?.cities?.map((city) => ({
          value: city.name,
          label: city.name,
        })) || [],
      )
    } else if (formData.tempCity && formData.tempCity !== "0") {
      // If we have a city but no country/state, create a single option for the existing city
      setCities([{ value: formData.tempCity, label: formData.tempCity }])
    } else {
      setCities([])
    }
  }, [formData.tempCountry, formData.tempState, formData.tempCity])

  // Load states based on permanent country
  useEffect(() => {
    if (formData.country) {
      const selectedCountry = countryStateCity.find((c) => c.name === formData.country)
      setPermStates(
        selectedCountry?.states?.map((state) => ({
          value: state.name,
          label: state.name,
        })) || [],
      )
    } else {
      setPermStates([])
    }
  }, [formData.country])

  // Load cities based on permanent state
  useEffect(() => {
    if (formData.country && formData.state) {
      const selectedCountry = countryStateCity.find((c) => c.name === formData.country)
      const selectedState = selectedCountry?.states?.find((s) => s.name === formData.state)
      setPermCities(
        selectedState?.cities?.map((city) => ({
          value: city.name,
          label: city.name,
        })) || [],
      )
    } else if (formData.city && formData.city !== "0") {
      // If we have a city but no country/state, create a single option for the existing city
      setPermCities([{ value: formData.city, label: formData.city }])
    } else {
      setPermCities([])
    }
  }, [formData.country, formData.state, formData.city])

  useEffect(() => {
    // Cleanup function to reset form when component unmounts
    return () => {
      setFormData(initialFormState)
    }
  }, [])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      const validTypes = ["image/jpeg", "image/png"]
      if (!validTypes.includes(file.type)) {
        alert("Please select a JPEG or PNG image.")
        return
      }

      setFormData((prev) => ({
        ...prev,
        patient_photo: file, // will replace the string if a file is chosen
      }))
    }
  }

  const handleMarriageEntryChange = (index, e) => {
    const { name, value } = e.target

    setFormData((prev) => ({
      ...prev,
      marriageEntries: prev.marriageEntries.map((entry, i) => (i === index ? { ...entry, [name]: value } : entry)),
    }))

    clearSpouseFieldError(name, index)
  }

  const addMarriageEntry = () => {
    const newIndex = formData.marriageEntries.length
    const newEntry = {
      marriageHistory: `${newIndex + 1}${getOrdinalSuffix(newIndex + 1)}`,
      marriageDate: "",
      spouseOption: "",
      spouseDetails: "",
      spouseName: "",
      spouseMobile: "",
      spouseEmail: "",
      spouseDOB: "",
      spouseGender: "",
      spouseDetails: null,
    }

    setFormData((prev) => ({
      ...prev,
      marriageEntries: [...prev.marriageEntries, newEntry],
    }))
  }

  const deleteMarriageEntry = (index) => {
    if (formData.marriageEntries.length <= 1) return // Prevent removing the last entry

    const updatedEntries = formData.marriageEntries.filter((_, i) => i !== index)

    // Recalculate marriageHistory ordinals
    const reOrdered = updatedEntries.map((entry, i) => ({
      ...entry,
      marriageHistory: `${i + 1}${getOrdinalSuffix(i + 1)}`,
    }))

    setFormData((prev) => ({
      ...prev,
      marriageEntries: reOrdered,
    }))
  }

  const getOrdinalSuffix = (n) => {
    const s = ["th", "st", "nd", "rd"],
      v = n % 100
    return s[(v - 20) % 10] || s[v] || s[0]
  }

  const calculateMarriageAge = (marriageDate) => {
    if (!marriageDate) return ""

    const today = new Date()
    const marriage = new Date(marriageDate)

    if (isNaN(marriage.getTime())) return ""

    let years = today.getFullYear() - marriage.getFullYear()
    let months = today.getMonth() - marriage.getMonth()
    let days = today.getDate() - marriage.getDate()

    // Adjust months and years if current day is before marriage day
    if (days < 0) {
      months--
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0)
      days += prevMonth.getDate() // Add days from the previous month
    }

    if (months < 0) {
      years--
      months += 12
    }

    const weeks = Math.floor(days / 7)

    const parts = []
    if (years > 0) parts.push(`${years} y${years > 1 ? "" : ""}`)
    if (months > 0) parts.push(`${months} m${months > 1 ? "" : ""}`)
    if (weeks > 0) parts.push(`${weeks} w${weeks > 1 ? "" : ""}`)

    return parts.join(", ") || "0 weeks"
  }

  const formatMarriageEntriesForAPI = (entries) => {
    return entries.map((entry) => {
      const withSpouse = entry.spouseOption === "withSpouse"
      return {
        marriageNumber: entry.marriageHistory,
        dateOfMarriage: entry.marriageDate,
        withSpouse: withSpouse.toString(), // "true" or "false"
        spouseName: withSpouse ? "" : entry.spouseName,
        marriageAge: calculateMarriageAge(entry.marriageDate).toString(),
        spousedetails: withSpouse ? entry.spouseDetails : "",
        spouse_name: withSpouse ? entry.spouseName ?? "" : "",
        spousedetails: withSpouse ? entry.spouseDetails : "", // Use null if not withSpouse
        spouse_mobile: withSpouse ? entry.spouseMobile ?? "" : "",
        spouse_email: withSpouse ? entry.spouseEmail ?? "" : "",
        spouse_dob: withSpouse ? entry.spouseDOB ?? "" : "",
        spouse_gender: withSpouse ? entry.spouseGender ?? "" : "",
        spouse_occupation: withSpouse ? entry.spouseOccupation ?? "" : "",
      }
    })
  }
  // id proof
  const idProofOptions = [
    { value: "PAN", label: "PAN" },
    { value: "Aadhar", label: "Aadhar" },
    { value: "Driving License", label: "Driving License" },
  ]
  //spouse

  const patients = useSelector((state) => state.patients.patients || [])

  const patientOptions = formatPatientsForDropdown(patients)

  // const handleGenderChange = (selectedOption) => {
  //   const gender = selectedOption.value;

  //   setFormData((prev) => ({
  //     ...prev,
  //     gender: gender,
  //   }));
  //   dispatch(getPatientlistbygenderAction(gender)); // Call API when gender changes
  // };
  const handleGenderChange = (selectedOption) => {
    const gender = selectedOption?.value || ""

    setFormData((prev) => ({
      ...prev,
      gender,
    }))

    if (gender && errors.gender) {
      setErrors((prev) => {
        const newErrors = { ...prev }
        delete newErrors.gender
        return newErrors
      })
    }

    if (gender) {
      dispatch(getPatientlistbygenderAction(gender))
    }
  }

  const handleSelectChange = (selectedOption, index) => {
    // if (formData.gender === "" ) {
    //   alert('Please select Gender.');
    //     return;
    // }
    setFormData((prevFormData) => {
      const updatedEntries = [...prevFormData.marriageEntries]
      updatedEntries[index] = {
        ...updatedEntries[index],
        spouseDetails: selectedOption ? selectedOption.value : null,
      }
      return {
        ...prevFormData,
        marriageEntries: updatedEntries,
      }
    })
  }

  const handleTextDateChange = (e) => {
    const { value } = e.target

    // Optional: validate DD-MM-YYYY format here
    setFormData((prev) => ({
      ...prev,
      date_of_birth: value,
    }))
  }
  const convertDateToDDMMYYYY = (inputDate) => {
    if (!inputDate) return ""
    const [year, month, day] = inputDate.split("-")
    return `${day}-${month}-${year}`
  }
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!validateForm())
  //     return;

  //   // if (isLoading) return; // prevent double submit
  //   // setIsLoading(true)

  //   if (loading) return; // prevent double-click
  //   setLoading(true);
  //   setFetching(true);
  //   try {
  //     // Prepare submit data
  //     const submitData = {
  //       ...formData,
  //       branch: formData.branch,
  //     };

  //     console.log("Input data for patient:", submitData);

  //     let resultPatientId;

  //     // If we have patientId from URL params, we're in edit mode
  //     if (patientId) {
  //       // Add the patient_id to the submitData for update
  //       submitData.patient_id = patientId;
  //       await dispatch(updatePatientAction(submitData));
  //       resultPatientId = patientId;
  //     } else {
  //       // Create new patient
  //       const result = await dispatch(createPatientAction(submitData));
  //       resultPatientId = result?.patient_id;
  //     }

  //     if (!resultPatientId) {
  //       throw new Error("Patient operation failed");
  //     }

  //     console.log("Patient ID:", resultPatientId);

  //     // 2. Add marriage info if married
  //     const formattedMarriageData = formatMarriageEntriesForAPI(
  //       formData.marriageEntries
  //     );
  //     console.log(
  //       "Sending to API MARRIAGE:",
  //       JSON.stringify(formattedMarriageData)
  //     );

  //     await dispatch(
  //       addMarriageInfoAction({
  //         patient_id: resultPatientId,
  //         is_married: formData.maritalStatus,
  //         marriage_entries:
  //           formData.maritalStatus === "Yes" ? formattedMarriageData : null,
  //       })
  //     );

  //     // 3. Add address info
  //     const temporary_address = {
  //       addressLine1: formData.tempAddressLine1 || "",
  //       addressLine2: formData.tempAddressLine2 || "",
  //       area: formData.tempArea || "",
  //       city: formData.tempCity || "",
  //       state: formData.tempState || "",
  //       country: formData.tempCountry || "",
  //       pincode: formData.tempPincode || "",
  //     };

  //     const permanent_address = {
  //       addressLine1: formData.addressLine1 || "",
  //       addressLine2: formData.addressLine2 || "",
  //       area: formData.area || "",
  //       city: formData.city || "",
  //       state: formData.state || "",
  //       country: formData.country || "",
  //       pincode: formData.pincode || "",
  //       useTemporaryAsPermanent: formData.useTempAddress,
  //     };

  //     console.log("temporary_address JSON:", JSON.stringify(temporary_address));
  //     console.log("permanent_address JSON:", JSON.stringify(permanent_address));

  //     await dispatch(
  //       addAddressInfoAction({
  //         patient_id: resultPatientId,
  //         temporary_address: JSON.stringify(temporary_address),
  //         permanent_address: JSON.stringify(permanent_address),
  //       })
  //     );

  //     // 4. Add Other info
  //     await dispatch(
  //       addOtherInfoAction({
  //         patient_id: resultPatientId,
  //         ad_name: formData.adName,
  //         ad_Set: formData.adSet,
  //         campaign_name: formData.campaignName,
  //         lead_source: formData.leadSource,
  //         status: formData.status,
  //         priority: formData.priority,
  //         modified_by: formData.modifiedBy,
  //         user_type: formData.userType,
  //         treatment_history: formData.treatmentHistory,
  //       })
  //     );

  //     // Show success message
  //     handleSuccess(
  //       `Patient successfully ${patientId ? "updated" : "created"}!`
  //     );

  //     // Reset form and navigate with a small delay to ensure state updates
  //     setTimeout(() => {
  //       setFormData(initialFormState);
  //       navigate("/app-patients", { replace: true });
  //     }, 1000);
  //   } catch (error) {
  //     console.error("Patient operation error:", error);
  //     showErrorAlert(
  //       `Failed to ${patientId ? "update" : "create"} patient: ${error.message}`
  //     );
  //   } finally {
  //     setLoading(false);
  //     setFetching(false);
  //   }

  // };
  const handleSubmit = async (e) => {
    e.preventDefault()

    // 🔹 Step 1: Start button loader first
    setLoading(true)

    // Let the button loader render before showing full-page loader
    await new Promise((resolve) => setTimeout(resolve, 300))

    // 🔹 Step 2: Now show the full-page loader
    setFetching(true)

    // Validate the form
    if (!validateForm()) {
      setLoading(false)
      setFetching(false)
      return
    }

    try {
      const submitData = {
        ...formData,
        branch: formData.branch,
      }

      let resultPatientId

      if (patientId) {
        submitData.patient_id = patientId
        await dispatch(updatePatientAction(submitData))
        resultPatientId = patientId
      } else {
        const result = await dispatch(createPatientAction(submitData))
        resultPatientId = result?.patient_id
      }

      if (!resultPatientId) throw new Error("Patient operation failed")

      const formattedMarriageData = formatMarriageEntriesForAPI(formData.marriageEntries)

      await dispatch(
        addMarriageInfoAction({
          patient_id: resultPatientId,
          is_married: formData.maritalStatus,
          marriage_entries: formData.maritalStatus === "Yes" ? formattedMarriageData : null,
        }),
      )

      const temporary_address = {
        addressLine1: formData.tempAddressLine1 || "",
        addressLine2: formData.tempAddressLine2 || "",
        area: formData.tempArea || "",
        city: formData.tempCity || "",
        state: formData.tempState || "",
        country: formData.tempCountry || "",
        pincode: formData.tempPincode || "",
      }

      const permanent_address = {
        addressLine1: formData.addressLine1 || "",
        addressLine2: formData.addressLine2 || "",
        area: formData.area || "",
        city: formData.city || "",
        state: formData.state || "",
        country: formData.country || "",
        pincode: formData.pincode || "",
        useTemporaryAsPermanent: formData.useTempAddress,
      }

      await dispatch(
        addAddressInfoAction({
          patient_id: resultPatientId,
          temporary_address: JSON.stringify(temporary_address),
          permanent_address: JSON.stringify(permanent_address),
        }),
      )

      await dispatch(
        addOtherInfoAction({
          patient_id: resultPatientId,
          ad_name: formData.adName,
          ad_Set: formData.adSet,
          campaign_name: formData.campaignName,
          lead_source: formData.leadSource,
          status: formData.status,
          priority: formData.priority,
          modified_by: formData.modifiedBy,
          user_type: formData.userType,
          treatment_history: formData.treatmentHistory,
        }),
      )

      handleSuccess(`Patient successfully ${patientId ? "updated" : "created"}!`)

      setTimeout(() => {
        setFormData(initialFormState)
        navigate("/app-patients", { replace: true })
      }, 800)
    } catch (error) {
      console.error("Patient operation error:", error)
      showErrorAlert(`Failed to ${patientId ? "update" : "create"} patient: ${error.message}`)
    } finally {
      // Stop both loaders
      setLoading(false)
      setFetching(false)
    }
  }

  const genderOptions = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
    { value: "Transgender", label: "Transgender" },
  ]
  const handleBack = () => {
    // Clear any cached patient data and reset form
    setFormData(initialFormState)
    navigate(-1) // Go back one page in history
  }

  // Error display component
  const ErrorMessage = ({ error }) => {
    if (!error) return null
    return <div className="text-danger small mt-1">{error}</div>
  }

  const handleDiseasesChange = (selectedOptions) => {
    const values = selectedOptions ? selectedOptions.map((opt) => String(opt.value)) : []

    handleChange({
      target: {
        name: "disease_names",
        value: values,
      },
    })

    // Manually validate and update the error
    if (values.length === 0) {
      setErrors((prev) => ({
        ...prev,
        disease_names: "At least one disease must be selected",
      }))
    } else {
      setErrors((prev) => ({
        ...prev,
        disease_names: "", // clear the error if selected
      }))
    }
  }

  if (fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    )
  }

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          <div className="d-flex justify-content-end p-3">
            <Link to="/app-patients" className="btn btn-link p-0">
              <Button variant="primary">Back</Button>
            </Link>
          </div>
          <div className="card">
            <div className="card-body">
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "20px",
                  marginTop: "20px",
                }}
              >
                <h5 style={{ fontSize: "24px", margin: 0 }}>{patientId ? "Edit Patient" : "Add New Patient"}</h5>
              </div>

              <form onSubmit={handleSubmit}>
                {/* Personal Information Subheading */}

                <div className="row">
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Patient Code</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Patient Code"
                      name="patient_code"
                      value={formData.patient_code || ""}
                      onChange={handleChange}
                      readOnly
                    />
                  </div>
                </div>
                <div className="row">
                  {/* First Name */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["first_name"] = el)}>
                    <label className="form-label">
                      First Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      // ref={fieldRefs.first_name}
                      type="text"
                      className="form-control"
                      placeholder="Enter first name"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.first_name && <small className="text-danger">{errors.first_name}</small>}
                  </div>

                  {/* Middle Name */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Middle Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter middle name"
                      name="middle_name"
                      value={formData.middle_name}
                      onChange={handleChangeWithValidation}
                    />
                    {/* {errors.middle_name && <small className="text-danger">{errors.middle_name}</small>} */}
                  </div>

                  {/* Last Name */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["last_name"] = el)}>
                    <label className="form-label">
                      Last Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      // ref={fieldRefs.last_name}
                      type="text"
                      className="form-control"
                      placeholder="Enter last name"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.last_name && <small className="text-danger">{errors.last_name}</small>}
                  </div>
                </div>
                <div className="row">
                  {/* Email */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["patient_email"] = el)}>
                    <label className="form-label">Email</label>
                    <input
                      // ref={fieldRefs.patient_email}
                      type="email"
                      className="form-control"
                      placeholder="Enter patient email"
                      name="patient_email"
                      value={formData.patient_email}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.patient_email && <small className="text-danger">{errors.patient_email}</small>}
                  </div>
                  {/* Contact Number */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["whatsapp_contact_no"] = el)}>
                    <label className="form-label">
                      Whatsapp Contact Number
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      // ref={fieldRefs.whatsapp_contact_no}
                      type="text"
                      className="form-control"
                      placeholder="Enter Whatsapp contact number"
                      name="whatsapp_contact_no"
                      value={formData.whatsapp_contact_no}
                      onChange={handleChangeWithValidation}
                      maxLength="10"
                    />
                    {errors.whatsapp_contact_no && <small className="text-danger">{errors.whatsapp_contact_no}</small>}
                  </div>
                  {/* Additional Contact Number */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["additional_contact_no"] = el)}>
                    <label className="form-label">Additional Contact Number</label>
                    <input
                      // ref={fieldRefs.additional_contact_no}
                      type="text"
                      className="form-control"
                      placeholder="Enter additional contact number"
                      name="additional_contact_no"
                      value={formData.additional_contact_no}
                      onChange={handleChangeWithValidation}
                      maxLength="10"
                    />
                    {errors.additional_contact_no && (
                      <small className="text-danger">{errors.additional_contact_no}</small>
                    )}
                  </div>
                </div>
                <div className="row">
                  {/* Photo */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["patient_photo"] = el)}>
                    <label className="form-label">Photo</label>

                    <div className="input-group">
                      {/* Hidden native file input */}
                      <input
                        // ref={fieldRefs.patient_photo}
                        type="file"
                        id="patientPhotoInput"
                        accept=".jpg,.jpeg,.png"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                      />

                      {/* Custom Choose File Button */}
                      <label htmlFor="patientPhotoInput" className="btn btn-outline-primary">
                        Choose File
                      </label>

                      {/* Filename display */}
                      <input
                        type="text"
                        className="form-control"
                        readOnly
                        value={
                          formData.patient_photo
                            ? typeof formData.patient_photo === "string"
                              ? formData.patient_photo.split("/").pop()
                              : formData.patient_photo.name
                            : ""
                        }
                      />

                      {/* Clear Button */}
                      {formData.patient_photo && (
                        <span
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "20%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontSize: "18px",
                            lineHeight: 1,
                          }}
                          title="Clear"
                          onClick={() =>
                            setFormData((prev) => ({
                              ...prev,
                              patient_photo: "",
                            }))
                          }
                        >
                          ×
                        </span>
                      )}
                    </div>

                    {/* Show validation error */}
                    {errors.patient_photo && <small className="text-danger">{errors.patient_photo}</small>}

                    {/* ✅ Image Preview */}
                    {(formData.patient_photo || formData.profileImage1) && (
                      <div className="mt-3 text-center">
                        <img
                          src={
                            typeof formData.patient_photo === "string"
                              ? formData.patient_photo
                              : URL.createObjectURL(formData.patient_photo)
                          }
                          alt="Preview"
                          style={{
                            maxHeight: "150px",
                            borderRadius: "8px",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    )}
                  </div>

                  {/* Gender */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">
                      Gender<span style={{ color: "red" }}>*</span>
                    </label>
                    <div ref={(el) => (fieldRefs.current["gender"] = el)}>
                      <Select
                        // ref={fieldRefs.gender}
                        name="gender"
                        options={[
                          { value: "Male", label: "Male" },
                          { value: "Female", label: "Female" },
                          { value: "Transgender", label: "Transgender" },
                        ]}
                        value={formData.gender ? { value: formData.gender, label: formData.gender } : null}
                        onChange={handleGenderChange}
                        placeholder="Select Gender"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            minHeight: "50px",
                            height: "50px",
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            lineHeight: "50px",
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            padding: "4px",
                          }),
                          indicatorSeparator: (provided) => ({
                            ...provided,
                            display: "none",
                          }),
                        }}
                      />
                    </div>
                    {errors.gender && <small className="text-danger">{errors.gender}</small>}
                  </div>

                  {/* Date of Birth */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["date_of_birth"] = el)}>
                    <label className="form-label">
                      Date of Birth<span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="form-group position-relative">
                      <input
                        // ref={fieldRefs.date_of_birth}
                        type="date"
                        className="form-control"
                        name="date_of_birth"
                        value={formData.date_of_birth}
                        onChange={handleTextDateChange}
                        max={new Date().toISOString().split("T")[0]}
                      />
                      <i
                        className="fa fa-calendar position-absolute"
                        style={{
                          right: "15px", // Adjust the spacing from the right
                          top: "50%", // Center the icon vertically
                          transform: "translateY(-50%)", // Adjust for perfect centering
                          pointerEvents: "none", // Prevent icon from blocking input interactions
                          fontSize: "18px", // Adjust the icon size
                          zIndex: 1, // Ensure icon appears on top
                        }}
                      ></i>
                    </div>
                    {errors.date_of_birth && <small className="text-danger">{errors.date_of_birth}</small>}
                  </div>

                  {/* Height in cm */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["height"] = el)}>
                    <label className="form-label">
                      Height (cm)<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      // ref={fieldRefs.height}
                      type="number"
                      className="form-control"
                      placeholder="Enter height"
                      name="height"
                      value={formData.height}
                      onChange={handleChangeWithValidation}
                      min="1"
                      max="300"
                    />
                    {errors.height && <small className="text-danger">{errors.height}</small>}
                  </div>

                  {/* Weight in kg */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["weight"] = el)}>
                    <label className="form-label">
                      Weight (kg)<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      //ref={fieldRefs.weight}
                      type="number"
                      className="form-control"
                      placeholder="Enter weight"
                      name="weight"
                      value={formData.weight}
                      onChange={handleChangeWithValidation}
                      min="1"
                      max="200"
                    />
                    {errors.weight && <small className="text-danger">{errors.weight}</small>}
                  </div>
                  {/* Occupation */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["occupation"] = el)}>
                    <label className="form-label">
                      Occupation<span style={{ color: "red" }}>*</span>
                    </label>
                    {/* <Select
                      name="occupation"
                      value={formData.occupation}
                      onChange={handleChangeWithValidation}
                    /> */}
                    <Select
                      name="occupation"
                      //ref={fieldRefs.occupation}
                      //value={formData.occupation}
                      //onChange={handleChangeWithValidation}
                      options={occupationOptions}
                      value={occupationOptions.find((opt) => opt.value === formData.occupation)}
                      onChange={(selectedOption) =>
                        setFormData((prev) => ({ ...prev, occupation: selectedOption.value }))
                      }
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.occupation && <small className="text-danger">{errors.occupation}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["id_proof"] = el)}>
                    <label className="form-label">
                      ID Proof<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      // ref={fieldRefs.id_proof}
                      name="id_proof"
                      options={idProofOptions}
                      value={idProofOptions.find((option) => option.value === formData.id_proof) || null}
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "id_proof",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select ID Proof"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.id_proof && <small className="text-danger">{errors.id_proof}</small>}
                  </div>

                  {/* ID Number */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["id_number"] = el)}>
                    <label className="form-label">
                      ID Number<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      // ref={fieldRefs.id_number}
                      type="text"
                      className="form-control"
                      placeholder="Enter ID number"
                      name="id_number"
                      value={formData.id_number}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.id_number && <small className="text-danger">{errors.id_number}</small>}
                  </div>
                  {/* Diseases */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["disease_names"] = el)}>
                    <label className="form-label">
                      Diseases<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      // ref={fieldRefs.disease_names}
                      isMulti
                      options={diseases.map((d) => ({
                        value: String(d.disease_id),
                        label: d.disease_name,
                      }))}
                      value={
                        formData.disease_names?.length > 0
                          ? diseases
                              .filter((d) => formData.disease_names.includes(String(d.disease_id)))
                              .map((d) => ({
                                value: String(d.disease_id),
                                label: d.disease_name,
                              }))
                          : []
                      }
                      onChange={handleDiseasesChange}
                      placeholder="Select Diseases"
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                        }),
                        multiValue: (provided) => ({
                          ...provided,
                          backgroundColor: "#f0f0f0",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.disease_names && <small className="text-danger">{errors.disease_names}</small>}
                  </div>
                </div>

                <h6 className="mt-4" style={{ fontSize: "24px" }}>
                  Marriage Information
                </h6>
                <div className="row mb-3">
                  {/* Married Checkbox */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label fw-bold">Married</label>
                    <div
                      className="form-check d-flex align-items-center justify-content-start"
                      style={{ height: "40px" }} // Adjust height as needed
                    >
                      <input
                        type="checkbox"
                        className="form-check-input me-2"
                        id="maritalStatusCheckbox"
                        checked={formData.maritalStatus === "Yes"}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            maritalStatus: e.target.checked ? "Yes" : "No",
                          }))
                        }
                      />
                      <label
                        className="form-check-label m-0"
                        htmlFor="maritalStatusCheckbox"
                        style={{ cursor: "pointer" }}
                      >
                        Yes
                      </label>
                    </div>
                  </div>
                </div>

                {formData.maritalStatus === "Yes" && (
                  <div className="marriage">
                    {formData.marriageEntries.map((entry, index) => (
                      <div
                        key={index}
                        className="marriage-entry mb-4 p-3"
                        // style={{ border: "1px solid #eee", borderRadius: "8px", background: "#f9f9f9" }}
                      >
                        <div className="row align-items-center mb-3">
                          <div className="col-10">
                            <h6 className="mb-0">Marriage Entry #{index + 1}</h6>
                          </div>
                          <div className="col-2 text-end">
                            {formData.marriageEntries.length > 1 && (
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => deleteMarriageEntry(index)}
                              >
                                <i className="fa fa-trash"></i> Delete
                              </button>
                            )}
                          </div>
                        </div>

                        <div className="row">
                          {/* Marriage History */}
                          <div className="col-xl-4 mb-3">
                            <label className="form-label fw-bold">
                              Marriage History
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <select
                              className="form-select"
                              name="marriageHistory"
                              value={entry.marriageHistory}
                              onChange={(e) => handleMarriageEntryChange(index, e)}
                              style={{ height: "50px" }}
                            >
                              <option value="1st">1st</option>
                              <option value="2nd">2nd</option>
                              <option value="3rd">3rd</option>
                              <option value="3rd">3rd</option>
                              <option value="4th">4th</option>
                            </select>
                          </div>

                          {/* Date of Marriage */}
                          <div
                            className="col-xl-4 mb-3"
                            ref={(el) => (fieldRefs.current[`marriageDate_${index}`] = el)}
                          >
                            <label className="form-label fw-bold">
                              Date of Marriage
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              name="marriageDate"
                              value={entry?.marriageDate ?? ""}
                              onChange={(e) => handleMarriageEntryChange(index, e)}
                              max={new Date().toISOString().split("T")[0]}
                              style={{ height: "50px" }}
                            />
                            {errors[`marriageDate_${index}`] && (
                              <small className="text-danger">{errors[`marriageDate_${index}`]}</small>
                            )}
                          </div>

                          {/* Marriage Age */}
                          {entry.marriageDate && (
                            <div className="col-xl-4 mb-3">
                              <label className="form-label fw-bold">
                                Marriage Age
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                // ref={fieldRefs.marriageAge}
                                type="text"
                                className="form-control"
                                value={calculateMarriageAge(entry.marriageDate)}
                                readOnly
                                style={{
                                  height: "50px",
                                  backgroundColor: "#f8f9fa",
                                }}
                              />
                            </div>
                          )}
                        </div>

                        {/* <div className="row">
                          
                          <div className="col-xl-4 mb-3">
                            <label className="form-label fw-bold">
                              With Spouse
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="d-flex align-items-center gap-4 mt-2">
                              <div className="form-check d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="form-check-input me-2"
                                  id={`withSpouse-${index}`}
                                  name={`spouseOption-${index}`}
                                  value="withSpouse"
                                  checked={entry.spouseOption === "withSpouse"}
                                  onChange={() =>
                                    handleMarriageEntryChange(index, {
                                      target: {
                                        name: "spouseOption",
                                        value: "withSpouse",
                                      },
                                    })
                                  }
                                />
                                <label
                                  className="form-check-label mb-0"
                                  htmlFor={`withSpouse-${index}`}
                                >
                                  Yes
                                </label>
                              </div>

                              <div className="form-check d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="form-check-input me-2"
                                  id={`withoutSpouse-${index}`}
                                  name={`spouseOption-${index}`}
                                  value="withoutSpouse"
                                  checked={
                                    entry.spouseOption === "withoutSpouse"
                                  }
                                  onChange={() =>
                                    handleMarriageEntryChange(index, {
                                      target: {
                                        name: "spouseOption",
                                        value: "withoutSpouse",
                                      },
                                    })
                                  }
                                />
                                <label
                                  className="form-check-label mb-0"
                                  htmlFor={`withoutSpouse-${index}`}
                                >
                                  No
                                </label>
                              </div>
                            </div>
                          </div>

                         
                          <div className="col-xl-4 mb-3" ref={(el) =>
                            fieldRefs.current[
                            entry.spouseOption === "withSpouse"
                              ? `spouseDetails_${index}`
                              : `spouseName_${index}`
                            ] = el
                          }>
                            {entry.spouseOption === "withSpouse" ? (
                              <>
                                <label className="form-label fw-bold">
                                  Spouse Details
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  //ref={fieldRefs.spouseDetails}
                                  name={`spouseDetails-${index}`}
                                  options={patientOptions}
                                  value={
                                    entry.spouseDetails
                                      ? patientOptions.find(
                                        (opt) =>
                                          opt.value === entry.spouseDetails
                                      )
                                      : null
                                  }
                                  onChange={(selectedOption) =>
                                    handleSelectChange(selectedOption, index)
                                  }
                                  placeholder="Select Spouse from Patients"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "50px",
                                      height: "50px",
                                    }),
                                  }}
                                />
                                {errors[`spouseDetails_${index}`] && <small className="text-danger">{errors[`spouseDetails_${index}`]}</small>}
                              </>
                            ) : (
                              <>
                                <label className="form-label fw-bold">
                                  Spouse Name{" "}
                                  {entry.spouseOption === "withSpouse" && (
                                    <span style={{ color: "red" }}>*</span>
                                  )}
                                </label>

                                <input
                                  //ref={fieldRefs.spouseName}
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Spouse Name"
                                  name="spouseName"
                                  value={entry.spouseName || ""}
                                  onChange={(e) =>
                                    handleMarriageEntryChange(index, e)
                                  }
                                  style={{ height: "50px" }}
                                />
                                {errors[`spouseName_${index}`] && <small className="text-danger">{errors[`spouseName_${index}`]}</small>}
                              </>
                            )}
                          </div>
                        </div> */}
                        <div className="row">
                          {/* Spouse Option */}
                          <div className="col-xl-4 mb-3">
                            <label className="form-label fw-bold">
                              With Spouse <span style={{ color: "red" }}>*</span>
                            </label>
                            <div className="d-flex align-items-center gap-4 mt-2">
                              {/* --- With Spouse (Yes) --- */}
                              <div className="form-check d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="form-check-input me-2"
                                  id={`withSpouse-${index}`}
                                  name={`spouseOption-${index}`}
                                  value="withSpouse"
                                  checked={entry.spouseOption === "withSpouse"}
                                  onChange={() =>
                                    handleMarriageEntryChange(index, {
                                      target: { name: "spouseOption", value: "withSpouse" },
                                    })
                                  }
                                />
                                <label className="form-check-label mb-0" htmlFor={`withSpouse-${index}`}>
                                  Yes
                                </label>
                              </div>

                              {/* --- Without Spouse (No) --- */}
                              <div className="form-check d-flex align-items-center">
                                <input
                                  type="radio"
                                  className="form-check-input me-2"
                                  id={`withoutSpouse-${index}`}
                                  name={`spouseOption-${index}`}
                                  value="withoutSpouse"
                                  checked={entry.spouseOption === "withoutSpouse"}
                                  onChange={() =>
                                    handleMarriageEntryChange(index, {
                                      target: { name: "spouseOption", value: "withoutSpouse" },
                                    })
                                  }
                                />
                                <label className="form-check-label mb-0" htmlFor={`withoutSpouse-${index}`}>
                                  No
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ============= WITH SPOUSE ============= */}
                        {entry.spouseOption === "withSpouse" && (
                          <>
                            {/* ---- First Row: Spouse Details + Mobile + Email ---- */}
                            <div className="row mt-3">
                              <div
                                className="col-xl-4 mb-3"
                                ref={(el) => (fieldRefs.current[`spouseDetails_${index}`] = el)}
                              >
                                <label className="form-label fw-bold">
                                  Spouse Details <span style={{ color: "red" }}>*</span>
                                </label>
                                <Select
                                  name={`spouseDetails-${index}`}
                                  options={patientOptions}
                                  value={
                                    entry.spouseDetails
                                      ? patientOptions.find((opt) => opt.value === entry.spouseDetails)
                                      : null
                                  }
                                  onChange={(selectedOption) => handleSelectChange(selectedOption, index)}
                                  placeholder="Select Spouse from Patients"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: "50px",
                                      height: "50px",
                                    }),
                                  }}
                                />
                                {errors[`spouseDetails_${index}`] && (
                                  <small className="text-danger">{errors[`spouseDetails_${index}`]}</small>
                                )}
                              </div>

                              <div className="col-xl-4 mb-3">
                                <label className="form-label fw-bold">Spouse Mobile</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Mobile Number"
                                  name="spouseMobile"
                                  value={entry.spouseMobile || ""}
                                  onChange={(e) => handleMarriageEntryChange(index, e)}
                                  maxLength="10"
                                  style={{ height: "50px" }}
                                />
                                {errors[`spouseMobile_${index}`] && (
                                  <small className="text-danger">{errors[`spouseMobile_${index}`]}</small>
                                )}
                              </div>

                              <div className="col-xl-4 mb-3">
                                <label className="form-label fw-bold">Spouse Email</label>
                                <input
                                  type="email"
                                  className="form-control"
                                  placeholder="Enter Email"
                                  name="spouseEmail"
                                  value={entry.spouseEmail || ""}
                                  onChange={(e) => handleMarriageEntryChange(index, e)}
                                  style={{ height: "50px" }}
                                />
                                {errors[`spouseEmail_${index}`] && (
                                  <small className="text-danger">{errors[`spouseEmail_${index}`]}</small>
                                )}
                              </div>
                            </div>

                            {/* ---- Second Row: DOB, Gender, Occupation ---- */}
                            <div className="row">
                              <div className="col-xl-4 mb-3">
                                <label className="form-label fw-bold">Spouse Date of Birth</label>
                                <input
                                  type="date"
                                  className="form-control"
                                  name="spouseDOB"
                                  value={entry.spouseDOB || ""}
                                  onChange={(e) => handleMarriageEntryChange(index, e)}
                                  max={new Date().toISOString().split("T")[0]}
                                  style={{ height: "50px" }}
                                />
                                {errors[`spouseDOB_${index}`] && (
                                  <small className="text-danger">{errors[`spouseDOB_${index}`]}</small>
                                )}
                              </div>

                              <div className="col-xl-4 mb-3">
                                <label className="form-label fw-bold">Spouse Gender</label>
                                <Select
                                  name="spouseGender"
                                  value={genderOptions.find((opt) => opt.value === entry.spouseGender) || null}
                                  onChange={(selectedOption) =>
                                    handleMarriageEntryChange(index, {
                                      target: {
                                        name: "spouseGender",
                                        value: selectedOption ? selectedOption.value : "",
                                      },
                                    })
                                  }
                                  options={genderOptions}
                                  placeholder="Select Gender"
                                  styles={{
                                    control: (base) => ({
                                      ...base,
                                      minHeight: "50px",
                                      borderColor: "#ced4da",
                                      boxShadow: "none",
                                    }),
                                    menu: (base) => ({
                                      ...base,
                                      zIndex: 9999,
                                    }),
                                  }}
                                />
                              </div>

                              <div className="col-xl-4 mb-3">
                                <label className="form-label fw-bold">Spouse Occupation</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Occupation"
                                  name="spouseOccupation"
                                  value={entry.spouseOccupation || ""}
                                  onChange={(e) => handleMarriageEntryChange(index, e)}
                                  style={{ height: "50px" }}
                                />
                                {errors[`spouseOccupation_${index}`] && (
                                  <small className="text-danger">{errors[`spouseOccupation_${index}`]}</small>
                                )}
                              </div>
                            </div>
                          </>
                        )}

                        {/* ============= WITHOUT SPOUSE ============= */}
                        {entry.spouseOption === "withoutSpouse" && (
                          <div className="row mt-3">
                            <div className="col-xl-4 mb-3">
                              <label className="form-label fw-bold">Spouse Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Spouse Name"
                                name="spouseName"
                                value={entry.spouseName || ""}
                                onChange={(e) => handleMarriageEntryChange(index, e)}
                                style={{ height: "50px" }}
                              />
                              {errors[`spouseName_${index}`] && (
                                <small className="text-danger">{errors[`spouseName_${index}`]}</small>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    ))}

                    <div className="row mt-3 mb-4">
                      <div className="col-2">
                        <button type="button" className="btn btn-primary" onClick={addMarriageEntry}>
                          <i className="fa fa-plus me-2"></i> Add
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <h6 className="mt-4" style={{ fontSize: "24px" }}>
                  Temporary Address
                </h6>
                <div className="row">
                  {/* Temporary Address Line 1 */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempAddressLine1"] = el)}>
                    <label className="form-label">
                      {" "}
                      Address Line 1<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      // ref={fieldRefs.tempAddressLine1}
                      className="form-control"
                      placeholder="Enter Address Line 1"
                      name="tempAddressLine1"
                      value={formData.tempAddressLine1}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.tempAddressLine1 && <small className="text-danger">{errors.tempAddressLine1}</small>}
                  </div>

                  {/* Temporary Address Line 2 */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempAddressLine2"] = el)}>
                    <label className="form-label">
                      {" "}
                      Address Line 2<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      //ref={fieldRefs.tempAddressLine2}
                      type="text"
                      className="form-control"
                      placeholder="Enter  Address Line 2"
                      name="tempAddressLine2"
                      value={formData.tempAddressLine2}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.tempAddressLine2 && <small className="text-danger">{errors.tempAddressLine2}</small>}
                  </div>

                  {/* Temporary Area */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempArea"] = el)}>
                    <label className="form-label">
                      {" "}
                      Area<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      //ref={fieldRefs.tempArea}
                      type="text"
                      className="form-control"
                      placeholder="Enter  Area"
                      name="tempArea"
                      value={formData.tempArea}
                      onChange={handleChangeWithValidation}
                    />
                    {errors.tempArea && <small className="text-danger">{errors.tempArea}</small>}
                  </div>

                  {/* Temporary Country */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempCountry"] = el)}>
                    <label className="form-label">
                      Country<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      //ref={fieldRefs.tempCountry}
                      name="tempCountry"
                      options={[{ value: "", label: "Select a Country" }, ...countries]}
                      value={
                        formData.tempCountry && formData.tempCountry !== "0"
                          ? countries.find((c) => String(c.value) === String(formData.tempCountry))
                          : null
                      }
                      onChange={(selectedOption) => {
                        const value = selectedOption?.value || ""
                        console.log("Temp Country selected:", value)
                        handleChangeWithValidation({
                          target: {
                            name: "tempCountry",
                            value: value,
                          },
                        })
                      }}
                      placeholder="Select a Country"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.tempCountry && <small className="text-danger">{errors.tempCountry}</small>}
                  </div>

                  {/* Temporary State */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempState"] = el)}>
                    <label className="form-label">
                      State<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      //ref={fieldRefs.tempState}
                      name="tempState"
                      options={[{ value: "", label: "Select a State" }, ...states]}
                      value={
                        formData.tempState && formData.tempState !== "0"
                          ? states.find((s) => String(s.value) === String(formData.tempState))
                          : null
                      }
                      onChange={(selectedOption) => {
                        const value = selectedOption?.value || ""
                        console.log("Temp State selected:", value)
                        handleChangeWithValidation({
                          target: {
                            name: "tempState",
                            value: value,
                          },
                        })
                      }}
                      placeholder="Select a State"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.tempState && <small className="text-danger">{errors.tempState}</small>}
                  </div>

                  {/* Temporary City */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempCity"] = el)}>
                    <label className="form-label">
                      City<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      //ref={fieldRefs.tempCity}
                      name="tempCity"
                      options={[{ value: "", label: "Select a City" }, ...cities]}
                      value={
                        formData.tempCity && formData.tempCity !== "0"
                          ? cities.find((c) => String(c.value) === String(formData.tempCity))
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "tempCity",
                            value: selectedOption?.value || "",
                          },
                        })
                      }
                      placeholder="Select a City"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.tempCity && <small className="text-danger">{errors.tempCity}</small>}
                  </div>

                  {/* Temporary Pincode */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["tempPincode"] = el)}>
                    <label className="form-label">
                      {" "}
                      Pincode<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      // ref={fieldRefs.tempPincode}
                      className="form-control"
                      placeholder="Enter Pincode"
                      name="tempPincode"
                      value={formData.tempPincode}
                      onChange={handleChangeWithValidation}
                      //pattern="[0-9]{6}"
                      maxLength="6"
                      inputMode="numeric"
                    />
                    {errors.tempPincode && <small className="text-danger">{errors.tempPincode}</small>}
                  </div>
                </div>
                <div className="d-flex align-items-center mb-3" style={{ gap: "10px" }}>
                  {/* <input
                    type="checkbox"
                    className="form-check-input m-0"
                    id="useTempAddress"
                    checked={formData.useTempAddress}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setFormData((prevState) => ({
                        ...prevState,
                        useTempAddress: checked,
                        ...(checked
                          ? {
                            addressLine1: prevState.tempAddressLine1,
                            addressLine2: prevState.tempAddressLine2,
                            area: prevState.tempArea,
                            country: prevState.tempCountry,
                            pincode: prevState.tempPincode,
                            city: prevState.tempCity,
                            state: prevState.tempState,
                          }
                          : {
                            addressLine1: "",
                            addressLine2: "",
                            area: "",
                            country: "",
                            state: "",
                            city: "",
                            pincode: "",
                          }),
                      }));
                    }}
                    style={{ marginTop: 0, flexShrink: 0 }} // Prevent shrinking of checkbox
                  /> */}
                  {/* <input
    type="checkbox"
    className="form-check-input"
    id="useTempAddress"
    checked={formData.useTempAddress}
    onChange={(e) => {
      const checked = e.target.checked;
      setFormData((prev) => ({
        ...prev,
        useTempAddress: checked,
        ...(checked
          ? {
              addressLine1: prev.tempAddressLine1,
              addressLine2: prev.tempAddressLine2,
              area: prev.tempArea,
              country: prev.tempCountry,
              state: prev.tempState,
              city: prev.tempCity,
              pincode: prev.tempPincode,
            }
          : {}),
      }));
    }}
  /> */}
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="useTempAddress"
                    checked={formData.useTempAddress}
                    onChange={(e) => {
                      const checked = e.target.checked
                      setFormData((prev) => ({
                        ...prev,
                        useTempAddress: checked,
                        ...(checked
                          ? {
                              addressLine1: prev.tempAddressLine1,
                              addressLine2: prev.tempAddressLine2,
                              area: prev.tempArea,
                              country: prev.tempCountry,
                              state: prev.tempState,
                              city: prev.tempCity,
                              pincode: prev.tempPincode,
                            }
                          : {}),
                      }))

                      // 🧹 FIX: Clear validation errors for permanent address when checked
                      if (checked) {
                        setErrors((prev) => {
                          const updatedErrors = { ...prev }
                          delete updatedErrors.addressLine1
                          delete updatedErrors.addressLine2
                          delete updatedErrors.area
                          delete updatedErrors.country
                          delete updatedErrors.state
                          delete updatedErrors.city
                          delete updatedErrors.pincode
                          return updatedErrors
                        })
                      }
                    }}
                  />

                  <div className="d-flex flex-column justify-content-center">
                    <label className="form-check-label fw-bold mb-0" htmlFor="useTempAddress">
                      Use Temporary Address as Permanent Address
                    </label>
                    {formData.useTempAddress && (
                      <p className="text-muted small mb-0 mt-1">
                        Temporary address will be saved as the permanent address.
                      </p>
                    )}
                  </div>
                </div>

                <h6 className="mt-4" style={{ fontSize: "24px" }}>
                  Permanent Address
                </h6>
                <div className="row">
                  {/* Address Line 1 */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["addressLine1"] = el)}>
                    <label className="form-label">
                      Address Line 1<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      //ref={fieldRefs.addressLine1}
                      type="text"
                      className="form-control"
                      placeholder="Enter Address Line 1"
                      name="addressLine1"
                      value={formData.addressLine1}
                      onChange={handleChangeWithValidation}
                      readOnly={formData.useTempAddress}
                    />
                    {errors.addressLine1 && <small className="text-danger">{errors.addressLine1}</small>}
                  </div>

                  {/* Address Line 2 */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["addressLine2"] = el)}>
                    <label className="form-label">
                      Address Line 2<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      //ref={fieldRefs.addressLine2}
                      type="text"
                      className="form-control"
                      placeholder="Enter Address Line 2"
                      name="addressLine2"
                      value={formData.addressLine2}
                      onChange={handleChangeWithValidation}
                      readOnly={formData.useTempAddress}
                    />
                    {errors.addressLine2 && <small className="text-danger">{errors.addressLine2}</small>}
                  </div>

                  {/* Area */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["area"] = el)}>
                    <label className="form-label">
                      Area<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      //ref={fieldRefs.area}
                      type="text"
                      className="form-control"
                      placeholder="Enter Area"
                      name="area"
                      value={formData.area}
                      onChange={handleChangeWithValidation}
                      readOnly={formData.useTempAddress}
                    />
                    {errors.area && <small className="text-danger">{errors.area}</small>}
                  </div>

                  {/* Country */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["country"] = el)}>
                    <label className="form-label">
                      Country<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      //ref={fieldRefs.country}
                      name="country"
                      options={permCountries}
                      value={permCountries.find((c) => c.value === formData.country) || null}
                      onChange={(selectedOption) => {
                        const value = selectedOption?.value || ""
                        handleChangeWithValidation({
                          target: {
                            name: "country",
                            value,
                          },
                        })
                      }}
                      placeholder="Select a Country"
                      isDisabled={formData.useTempAddress}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.country && <small className="text-danger">{errors.country}</small>}
                  </div>

                  {/* State */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["state"] = el)}>
                    <label className="form-label">
                      State<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      //ref={fieldRefs.state}
                      name="state"
                      options={[{ value: "", label: "Select a State" }, ...permStates]}
                      value={
                        formData.state && formData.state !== "0"
                          ? permStates.find((s) => String(s.value) === String(formData.state))
                          : null
                      }
                      onChange={(selectedOption) => {
                        const value = selectedOption?.value || ""
                        console.log("Perm State selected:", value)
                        handleChangeWithValidation({
                          target: {
                            name: "state",
                            value: value,
                          },
                        })
                      }}
                      placeholder="Select a State"
                      isDisabled={formData.useTempAddress}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.state && <small className="text-danger">{errors.state}</small>}
                  </div>

                  {/* City */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["city"] = el)}>
                    <label className="form-label">
                      City<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      // ref={fieldRefs.city}
                      name="city"
                      options={[{ value: "", label: "Select a City" }, ...permCities]}
                      value={
                        formData.city && formData.city !== "0"
                          ? permCities.find((c) => String(c.value) === String(formData.city))
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "city",
                            value: selectedOption?.value || "",
                          },
                        })
                      }
                      placeholder="Select a City"
                      isDisabled={formData.useTempAddress}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.city && <small className="text-danger">{errors.city}</small>}
                  </div>

                  {/* Pincode */}
                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["pincode"] = el)}>
                    <label className="form-label">
                      Pincode<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      //ref={fieldRefs.pincode}
                      type="text"
                      placeholder="Enter pincode"
                      className="form-control"
                      name="pincode"
                      value={formData.pincode}
                      isDisabled={formData.useTempAddress}
                      onChange={handleChangeWithValidation}
                      //pattern="[0-9]{6}"
                      maxLength="6"
                      inputMode="numeric"
                    />
                    {errors.pincode && <small className="text-danger">{errors.pincode}</small>}
                  </div>
                </div>
                <h6 className="mt-4" style={{ fontSize: "24px" }}>
                  Other Information
                </h6>
                <div className="row">
                  {/* Ad Name */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Ad Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Ad Name"
                      name="adName"
                      value={formData.adName}
                      onChange={handleChangeWithValidation}
                    />
                  </div>

                  {/* Ad Set */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Ad Set</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Ad Set"
                      name="adSet"
                      value={formData.adSet}
                      onChange={handleChangeWithValidation}
                    />
                  </div>

                  {/* Campaign Name */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Campaign Name</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Campaign Name"
                      name="campaignName"
                      value={formData.campaignName}
                      onChange={handleChangeWithValidation}
                    />
                  </div>
                </div>
                <div className="row">
                  {/* Lead Source Dropdown */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Lead Source</label>
                    <Select
                      name="leadSource"
                      options={[
                        { value: "Facebook", label: "Facebook" },
                        { value: "Instagram", label: "Instagram" },
                        { value: "Twitter", label: "Twitter" },
                      ]}
                      value={
                        formData.leadSource
                          ? {
                              value: formData.leadSource,
                              label: formData.leadSource,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "leadSource",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select Lead Source"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                  </div>

                  {/* Status Dropdown */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Status</label>
                    <Select
                      name="status"
                      options={[
                        { value: "New", label: "New" },
                        { value: "In Progress", label: "In Progress" },
                        { value: "Closed", label: "Closed" },
                        { value: "Follow-Up", label: "Follow-Up" },
                      ]}
                      value={formData.status ? { value: formData.status, label: formData.status } : null}
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "status",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select Status"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                  </div>

                  {/* Priority Dropdown */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Priority</label>
                    <Select
                      name="priority"
                      options={[
                        { value: "Low", label: "Low" },
                        { value: "Medium", label: "Medium" },
                        { value: "High", label: "High" },
                      ]}
                      value={
                        formData.priority
                          ? {
                              value: formData.priority,
                              label: formData.priority,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "priority",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select Priority"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                  </div>
                  {/* Modified By Field */}
                  <div className="col-xl-4 mb-3">
                    <label className="form-label">Modified By</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Modified By"
                      name="modifiedBy"
                      value={formData.modifiedBy}
                      readOnly // Make it read-only since it's derived from userType
                    />
                  </div>

                  {/* User Type Selection */}

                  <div className="col-xl-4 mb-3">
                    <label className="form-label">User Type</label>
                    <Select
                      name="userType"
                      options={adminUsers.map((user) => ({
                        value: user.role_id,
                        label: user.role_name,
                      }))}
                      value={
                        adminUsers
                          .map((user) => ({
                            value: user.role_id,
                            label: user.role_name,
                          }))
                          .find((option) => option.value === formData.userType) || null
                      }
                      onChange={(selectedOption) =>
                        setFormData((prev) => ({
                          ...prev,
                          userType: selectedOption?.value || "",
                          userTypeName: selectedOption?.label || "",
                        }))
                      }
                      placeholder="Select User Type"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                      }}
                    />
                  </div>

                  <div className="col-xl-4 mb-3" ref={(el) => (fieldRefs.current["branch"] = el)}>
                    <label className="form-label">
                      Branch<span style={{ color: "red" }}>*</span>
                    </label>
                    <Select
                      //ref={fieldRefs.branch}
                      name="branch"
                      options={branches.map((b) => ({
                        value: b.branch_id,
                        label: b.branch_name,
                      }))}
                      value={
                        formData.branch
                          ? {
                              value: formData.branch,
                              label: branches.find((b) => b.branch_id === formData.branch)?.branch_name,
                            }
                          : null
                      }
                      onChange={(selectedOption) =>
                        handleChangeWithValidation({
                          target: {
                            name: "branch",
                            value: selectedOption.value,
                          },
                        })
                      }
                      placeholder="Select Branch"
                      styles={{
                        control: (provided, state) => ({
                          ...provided,
                          minHeight: "50px",
                          height: "50px",
                          borderColor: state.isFocused
                            ? "#007bff"
                            : !formData.branch
                              ? "#dc3545"
                              : provided.borderColor,
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          lineHeight: "50px",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: "none",
                        }),
                      }}
                    />
                    {errors.branch && <small className="text-danger">{errors.branch}</small>}
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-12 mb-3">
                    <label className="form-label">Treatment History</label>
                    <textarea
                      className="form-control"
                      rows="3"
                      placeholder="Enter treatment history"
                      name="treatmentHistory"
                      value={formData.treatmentHistory}
                      onChange={handleChangeWithValidation}
                    />
                  </div>
                </div>
                {/* Save Button */}
                {/* <Button variant="primary" type="submit" disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      {patientId ? "Updating..." : "Saving..."}
                    </>
                  ) : patientId ? (
                    "Update"
                  ) : (
                    "Save"
                  )}
                </Button> */}

                {/* <button
  type="submit"
  className="btn btn-primary me-2"
  disabled={loading || fetching}
>
  {loading ? (
    <>
      <Loader size="sm" />
      <span className="ms-2">Submitting...</span>
    </>
  ) : (
    <>{patientId ? "Update Patient" : "Add Patient"}</>
  )}
</button> */}

                <button type="submit" className="btn btn-primary me-2" disabled={loading || fetching}>
                  {loading ? (
                    <>
                      <Loader size="sm" />
                      <span className="ms-2">{patientId ? "Updating..." : "Submitting..."}</span>
                    </>
                  ) : (
                    <>{patientId ? "Update Patient" : "Add Patient"}</>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddPatients
